import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import { accountService, alertService, lockerService } from '../_services';
import { fetchWrapper, history } from '../_helpers';
import { renderOptions, chooseMap, renderOptionsWithoutCurrentArea } from './NBMapFunctions';


import smallLockerSelect from "../assets/images/locker-select-small.png";
import largeLockerSelect from "../assets/images/locker-select-large.png";
import stdLockerSelect from "../assets/images/locker-select-standard.png";
import xlargeLockerSelect from "../assets/images/locker-select-x-large.png";

import surf_map from "../assets/images/surf-map.png";
import hillside_map from "../assets/images/hillside-map.png";
import wunder_map from "../assets/images/wunder-map.png";
import blast_map from "../assets/images/blast-map.png";
import tube_map from "../assets/images/tube-map.png";
import wave_map from "../assets/images/wave-map.png";


import { loadStripe } from '@stripe/stripe-js';

const imgs = {
    Small: smallLockerSelect,
    Large: largeLockerSelect,
    Standard: stdLockerSelect,
    Medium: stdLockerSelect,
    'X-Large': xlargeLockerSelect,
    none: ''
}

const area_imgs = {
    Blastenhoff: blast_map,
    Tubenbach: tube_map,
    Surfenburg: surf_map,
    Hillside: hillside_map,
    Wunder: wunder_map,
    Wave: wave_map,
    none: undefined,
    "": undefined
}
function TransferReservation({ history }) {

    function preloadImage(url) {
        var img = new Image();
        img.src = url;
        //console.log("preloaded" + url);
    }
    
    //lockerAreas is a semicolon delimted list of area names
    const [lockerAreas, setLockerAreas] = useState(accountService.configValue['lockerAreas'].split(";"));
    const [showTerms, setShowTerms] = useState(false);
    const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
    const [options, setOptions] = useState([]);
    const [lockerSelectImage, setLockerSelectImage] = useState(imgs['X-Large']);

    const [areaSelect, setAreaSelect] = useState(2); //0 - Closed - 1:East only 2:Full park 
    const [areaSelectImage, setAreaSelectImage] = useState(undefined); //0 - Closed - 1:East only 2:Full park 
    const [showAreaSelect, setShowAreaSelect] = useState(true);

    const [lockerArea, setLockerArea] = useState("");
    const [selectedArea, setSelectedArea] = useState("");
    const [soldOut, setSoldOut] = useState(false);
    const [parkClosed, setParkClosed] = useState(false);

    const [showLockerSelect, setShowLockerSelect] = useState(true);
    const [lockerType, setLockerType] = useState("X-Large");
    const [price, setPrice] = useState(0);

    const [initVals, setInitVals] = useState({
        area: "",
        lockerType: "X-Large",
        startDate: moment().format("YYYY-MM-DD").toString()
    });

    const stripeKey = accountService.configValue['stripePublicKey'];
    const stripePromise = loadStripe(stripeKey);
    const skipFee = (accountService.configValue['skipConvenienceCharge'] == 'true')

    let { reservationId } = useParams();

    async function fetchData() {
        setShowLockerSelect(false);
        let currentArea = await lockerService.getLockerAreaForReservation(reservationId);
        setLockerAreas(lockerAreas.filter(a => a != currentArea));
            
        let areasid = chooseMap(date);
        if (areasid != 0) {
            setParkClosed(false);
        } else {

            setParkClosed(true);
        }

        let tarea = (areasid != 0) ? lockerArea : "";

        setAreaSelect(areasid);

        if (lockerArea != "" && (typeof (lockerArea) != 'undefined')) {
            setAreaSelectImage(area_imgs[lockerArea]);
        } else {
            setAreaSelectImage(area_imgs["none"]);
        }

        //console.log("SELECT IMAGE:" + area_imgs[lockerArea])

        const data = await lockerService.getLockerInventoryForTransfer(date, lockerArea, reservationId);
        //console.log(data);
        if (lockerArea != "") {
            setShowLockerSelect(true);
            var all_sold_out = true;
            for (var index = 0; index < data.length; index++) {
                if (data[index].availability > 0) {
                    all_sold_out = false;
                    break
                }
            }
            setSoldOut(all_sold_out);
        }

        var first_price = data.sort((a, b) => (b.price > a.price) ? 1 : -1)[0]?.price;
        setPrice(first_price);

        setOptions(options => data);
        var ltype = ""
        var ttyp = "";
        //on load, or when the lockerType is not available in the data, reset the size display image.
        if (imgs[lockerType] == "" || (data.length != 0 && (data.filter(item => (item.availability > 0)).filter(row => row.name == lockerType)).length == 0)) {
            var first_type = data.filter(item => (item.availability > 0)).sort((a, b) => (a.price > b.price) ? 1 : -1)[0]?.name;
            ttyp = imgs[first_type || 'none'];
            setLockerType(first_type);
            ltype = first_type
        } else {
            ttyp = imgs[lockerType];
            ltype = lockerType;
        }

        setLockerSelectImage(ttyp);
        setInitVals({
            area: tarea,
            lockerType: ltype,
            startDate: date,
            acceptTerms: false,
            transferFromReservationId: reservationId
        });

    }

    useEffect(() => {
        for (var key in imgs) {
            preloadImage(imgs[key]);
        }
        preloadImage(surf_map);
        preloadImage(hillside_map);
        preloadImage(wunder_map)
        preloadImage(blast_map);
        preloadImage(tube_map);
        preloadImage(wave_map);
    }, []); //preload images on first load.

    useEffect(() => {
        fetchData();
    }, [lockerArea, reservationId]); //fetchData on  area or reservation ID change
    //array arg is "dependencies" for useEffect - empty means run once on component mount
    //when this includes date, the select stops working so include date as well

    let validationSchema = Yup.object().shape({
        lockerType: Yup.string()
            .required('Choose a Locker Type'),
        startDate: Yup.date()
            .required('Reservation Date is required')
    });

    async function stripe_redir(lockerType, newReservationId) {

        const stripe = await stripePromise;
        const response = await fetchWrapper.post('/create-checkout-session',
            {
                lockerType: lockerType,
                reservation_id: newReservationId,
                transfer_reservation_id: reservationId
            }
        );

        const session = await response;

        // skip stripe checkout if no payment is due
        if (price > 0) {
            // When the customer clicks on the button, redirect them to Checkout.
            const result = await stripe.redirectToCheckout({
                sessionId: session.id,
            });

            if (result.error) {
                // If `redirectToCheckout` fails due to a browser or network
                // error, display the localized error message to your customer
                // using `result.error.message`.
                alertService.error(result.error.message);
            }
        } else {
            history.push("/activate-reservation/" + newReservationId);
        }
    }

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        //console.log("ON SUBMIT FIELDS:");
        //console.log(fields);
        accountService.addReservation(fields)
            .then((data) => {
                //alertService.info('Reservation Step 2: Payment');
                stripe_redir(fields.lockerType, data.id);
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });

    }

    const handleSizeChange = (e) => {
        const selectedOption = e.target.options[e.target.selectedIndex];
        const price = selectedOption.getAttribute('data-price');
        setPrice(price);
        setLockerType(e.target.value);
        setLockerSelectImage(imgs[e.target.value] ? imgs[e.target.value] : imgs['none']);
    };
 
    const handleAreaSelectChange = (e) => {
        setAreaSelectImage(area_imgs[e.target.value]);
        setSelectedArea(e.target.value);
    };

    const handleAreaChange = (e) => {
        setShowAreaSelect(false);
        setLockerArea(selectedArea);
    };

        return (

        <div className="card m-3">
                <Formik enableReinitialize={true} initialValues={initVals} validationSchema={validationSchema} onSubmit={onSubmit} >
                    {({ errors, touched, isSubmitting, handleChange }) => (
                        <Form>
                            <div className="card-header">
                                <h1 className="bold-tx">Transfer Rental </h1>
                                <h5 className="mar-bot-0">Select New Area</h5>
                            </div>
                            <div className="card-body">
                                {showAreaSelect &&
                                    <>

                                        <Field type="hidden" className="form-control" name="startDate" />


                                        {!parkClosed &&
                                            <>
                                                <div className="form-row">
                                                    <div className="form-group col-6">
                                                        <label>Select Area</label>
                                                        <Field as="select"
                                                            name="Area"
                                                            onChange={(e) => { handleChange(e); handleAreaSelectChange(e, this); }}
                                                            className={'form-control' + (errors.area && touched.area ? ' is-invalid' : '')} >
                                                            <option key={'default'} value={""}>Select New Area . . .</option>

                                                         { renderOptions(areaSelect, lockerAreas) }

                                                        </Field>
                                                        <ErrorMessage name="Area" component="div" className="invalid-feedback" />
                                                    </div>
                                                </div>
                                                {(typeof (areaSelectImage) != "undefined") && (!parkClosed) &&
                                                    <>
                                                        <div className="form-row">
                                                            <div className="form-group">
                                                                <img className="locker-select" src={areaSelectImage} />
                                                            </div>
                                                        </div>
                                                        <button type="submit" onClick={(e) => { handleAreaChange(e, this); }} disabled={isSubmitting} className="btn btn-primary">
                                                            Choose this Area
                                                        </button>
                                                    </>
                                                }
                                            </>
                                        }
                                    </>
                                }


                                {(showLockerSelect && !soldOut) ?
                                    (
                                        <>
                                            <div className="form-row">
                                                <div className="form-group col-6">
                                                    <label>Location:{lockerArea}</label>
                                                </div>
                                            </div>

                                            <div className="form-row">
                                            {options.length > 1 && (
                                                <div className="form-group col-6">
                                                    <label>Select Size</label>
                                                    <Field as="select"
                                                        name="lockerType"
                                                        onChange={(e) => { handleChange(e); handleSizeChange(e, this); }}
                                                        className={'form-control' + (errors.lockerType && touched.lockerType ? ' is-invalid' : '')} >
                                                        {
                                                            options.filter(item => (item.availability > 0))
                                                                .sort((a, b) => (a.price > b.price) ? 1 : -1)
                                                                .map((option) => {
                                                                    //transfer does not add the $1 fee
                                                                return <option data-price={option.price}  key={option.name} value={option.name}> {option.name}    -    ${(((option.price * 100)) / 100)}</option>
                                                                }

                                                                )
                                                        }
                                                    </Field>
                                                    <ErrorMessage name="lockerType" component="div" className="invalid-feedback" />
                                                </div>
                                            )}
                                            </div>

                                            <div className="form-row">
                                                <div className="form-group">
                                                    <img className="locker-select" src={lockerSelectImage} />
                                                </div>
                                            </div>

                                            <div className="form-row">
                                                <div className="form-group">
                                                    {price <= 0 &&
                                                    <Field type="hidden" name="transferFromReservationId" value={reservationId } />
                                                    }

                                                    <button id="toPayment" type="submit" disabled={isSubmitting} className="btn btn-primary">
                                                        {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                                        Step 2 - {price <= 0 ? " Transfer " : " Payment ($" + price + ")"}
                                                    </button>


                                                </div>
                                            </div>
                                        </>
                                    )
                                    :
                                    ((!showLockerSelect) ? (
                                        <>

                                        </>
                                    ) :
                                        (
                                            <>
                                                <div className="form-row">
                                                    <div className="form-group">
                                                    <p> There are no lockers of the same size currently available at this area.</p>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    )
                                }
                            </div>

                            {parkClosed &&
                                <div className="form-row">
                                    <div className="form-group">
                                        <p> The park is closed on this date. Please try a different date. </p>
                                    </div>
                                </div>
                            }

                            <div>
                                <h3 className="card-header cust-footer">
                                    <Link to="/reservations/active" className="btn btn-link">Cancel</Link>
                                </h3>
                            </div>
                        </Form>
                    )}
                </Formik>
        </div>

    );

}


export { TransferReservation }; 